/**
 * Property Postcard Templates Configuration
 *
 * Templates optimized for Lob postcard sizes:
 * - 4x6: Standard postcard (1875 x 1275 pixels at 300 DPI)
 * - 6x9: Medium postcard (2775 x 1950 pixels at 300 DPI)
 * - 6x11: Large postcard (3375 x 1950 pixels at 300 DPI)
 */

export const POSTCARD_TEMPLATES = [
    {
        id: "just_listed",
        name: "Just Listed",
        badge: "JUST LISTED",
        description: "Announce a new property listing with high impact",
        useCase: "New Listings",
        accentColor: "#0f766e",
        textColor: "#1e293b",
        bgGradient: "from-stone-50 via-white to-slate-100",
        isDark: false,
    },
    {
        id: "open_house",
        name: "Open House",
        badge: "OPEN HOUSE",
        description: "Invite potential buyers to your open house event",
        useCase: "Events",
        accentColor: "#ea580c",
        textColor: "#1e293b",
        bgGradient: "from-orange-50 via-amber-50 to-orange-100",
        isDark: false,
    },
    {
        id: "price_reduced",
        name: "Price Reduced",
        badge: "PRICE REDUCED",
        description: "Highlight a price improvement with urgency",
        useCase: "Price Updates",
        accentColor: "#dc2626",
        textColor: "#1e293b",
        bgGradient: "from-rose-50 via-white to-red-50",
        isDark: false,
    },
    {
        id: "coming_soon",
        name: "Coming Soon",
        badge: "COMING SOON",
        description: "Build anticipation for an upcoming listing",
        useCase: "Pre-Launch",
        accentColor: "#7c3aed",
        textColor: "#1e293b",
        bgGradient: "from-violet-50 via-white to-purple-50",
        isDark: false,
    },
    {
        id: "just_sold",
        name: "Just Sold",
        badge: "JUST SOLD",
        description: "Showcase your success and attract new clients",
        useCase: "Success Stories",
        accentColor: "#15803d",
        textColor: "#1e293b",
        bgGradient: "from-emerald-50 via-white to-green-50",
        isDark: false,
    },
    {
        id: "luxury_estate",
        name: "Luxury Estate",
        badge: "EXCLUSIVE",
        description: "Premium dark theme for luxury properties",
        useCase: "Luxury",
        accentColor: "#d4a94f",
        textColor: "#ffffff",
        bgGradient: "from-slate-900 via-zinc-900 to-slate-950",
        isDark: true,
    },
    {
        id: "modern_minimal",
        name: "Modern Minimal",
        badge: "NEW LISTING",
        description: "Clean, contemporary design for modern homes",
        useCase: "Modern Homes",
        accentColor: "#0f172a",
        textColor: "#1e293b",
        bgGradient: "from-white via-slate-50 to-stone-100",
        isDark: false,
    },
    {
        id: "warm_family",
        name: "Warm Family",
        badge: "WELCOME HOME",
        description: "Inviting design for family homes",
        useCase: "Family Homes",
        accentColor: "#b45309",
        textColor: "#1e293b",
        bgGradient: "from-amber-50 via-orange-50 to-yellow-50",
        isDark: false,
    },
];

export const POSTCARD_SIZES = [
    {
        id: "4x6",
        name: "4x6 Standard",
        description: "Most popular - fits standard mailbox",
        widthInches: "6.25",
        heightInches: "4.25",
        aspectRatio: 6.25 / 4.25, // ~1.47
        recommended: true,
    },
    {
        id: "6x9",
        name: "6x9 Medium",
        description: "Larger format for more impact",
        widthInches: "9.25",
        heightInches: "6.5",
        aspectRatio: 9.25 / 6.5, // ~1.42
        recommended: false,
    },
    {
        id: "6x11",
        name: "6x11 Large",
        description: "Maximum presence - stands out",
        widthInches: "11.25",
        heightInches: "6.5",
        aspectRatio: 11.25 / 6.5, // ~1.73
        recommended: false,
    },
];

export const DEFAULT_POSTCARD_TEMPLATE = "just_listed";
export const DEFAULT_POSTCARD_SIZE = "4x6";

// Pricing for direct mail (informational)
export const POSTCARD_PRICING = {
    "4x6": { price: 0.75, label: "$0.75 + postage" },
    "6x9": { price: 0.85, label: "$0.85 + postage" },
    "6x11": { price: 0.95, label: "$0.95 + postage" },
};

// Get template by ID
export const getPostcardTemplate = (id) => {
    return POSTCARD_TEMPLATES.find((t) => t.id === id) || POSTCARD_TEMPLATES[0];
};

// Get size by ID
export const getPostcardSize = (id) => {
    return POSTCARD_SIZES.find((s) => s.id === id) || POSTCARD_SIZES[0];
};
